import { OrganizationKeyName } from "../../../model/Organization";

export const UPSERT_USER_TERM = "UPSERT_USER_TERM";
export type UpsertUserTermAction = {
  type: typeof UPSERT_USER_TERM;
  organization: OrganizationKeyName;
  data: any;
};
export const upsertUserTermAction = (
  organization: OrganizationKeyName,
  data: any
): UpsertUserTermAction => ({
  type: UPSERT_USER_TERM,
  organization,
  data,
});

export const UPSERT_USER_TERM_FAIL = "UPSERT_USER_TERM_FAIL";
export type UpsertUserTermFailAction = {
  type: typeof UPSERT_USER_TERM_FAIL;
  organization: OrganizationKeyName;
};
export const upsertUserTermFailAction = (
  organization: OrganizationKeyName
): UpsertUserTermFailAction => ({
  type: UPSERT_USER_TERM_FAIL,
  organization,
});

export const UPSERT_USER_TERM_SUCCESS = "UPSERT_USER_TERM_SUCESS";
export type UpsertUserTermSuccessAction = {
  type: typeof UPSERT_USER_TERM_SUCCESS;
  organization: OrganizationKeyName;
};
export const upsertUserTermSuccessAction = (
  organization: OrganizationKeyName
): UpsertUserTermSuccessAction => ({
  type: UPSERT_USER_TERM_SUCCESS,
  organization,
});
